import { runHawklinksWithPerformanceMeasurement } from '../hawklinks/browser/runHawklinksWithPerformanceMeasurement';
import { initiateApstagIntegration } from '../sharedModules/apstag/integration';

runHawklinksWithPerformanceMeasurement().then(initiateApstagIntegration);
